import { FC } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { DatePicker } from "../../../common/components/DatePicker/DatePicker";
import { List } from "../../../common/components/List/List";
import { OrderList } from "../../../common/components/Order/OrderList";
import { Tabs } from "../../../common/components/Tabs/Tabs";
import {
  setAvtiveOrderId,
  setDateFrom,
  setDateTo,
  setFinishedOrderStatus,
} from "./finishedOrderModerationSlice";
import { ORDER_STATUS } from "common/utils/consts";
import { IOrder } from "common/models/order/IOrder";

export const FinishedOrdersList: FC = () => {
  const activeOrderId = useAppSelector(
    (state) => state.platformManager.finishedOrderModeration.activeOrderId
  );
  const finishedOrderDateFrom = useAppSelector(
    (state) =>
      state.platformManager.finishedOrderModeration.finishedOrderDateFrom
  );
  const finishedOrdersDateTo = useAppSelector(
    (state) => state.platformManager.finishedOrderModeration.finishedOrderDateTo
  );
  const finishedOrderStatus = useAppSelector(
    (state) => state.platformManager.finishedOrderModeration.finishedOrderStatus
  );

  const dispatch = useAppDispatch();

  const handleSetActiveDisputeId = (order: IOrder) => {
    dispatch(setAvtiveOrderId(order.id));
  };

  const handleDisputesDateFromChange = (date: Nullable<Date>) => {
    dispatch(setDateFrom(date?.toLocaleDateString("sv") || undefined));
  };

  const handleDisputesDateToChange = (date: Nullable<Date>) => {
    dispatch(setDateTo(date?.toLocaleDateString("sv") || undefined));
  };

  const handleSetFinishedOrderStatus = (status: number) => {
    dispatch(setFinishedOrderStatus(status));
  };

  return (
    <>
      <Tabs
        tabs={[
          { value: ORDER_STATUS.ON_REVIEW, label: "На проверке" },
          { value: ORDER_STATUS.FINISHED, label: "Завершённые" },
        ]}
        value={finishedOrderStatus}
        onTabClick={handleSetFinishedOrderStatus}
      />

      <div>
        <DatePicker
          onStartDateChange={handleDisputesDateFromChange}
          onEndDateChange={handleDisputesDateToChange}
          placeholderText="Введите промежуток дат"
          isClearable={true}
        />
      </div>

      <List className="mt-[10px] overflow-y-scroll">
        <OrderList
          filter={{
            statusId: [finishedOrderStatus],
            dateFrom: finishedOrderDateFrom,
            dateTo: finishedOrdersDateTo,
          }}
          activeOrderId={activeOrderId}
          onItemClick={handleSetActiveDisputeId}
          withAddresses
          alwaysShowDate
        />
      </List>
    </>
  );
};
